export var AnimationType;
(function (AnimationType) {
    AnimationType["DRAW"] = "draw";
    AnimationType["COLLAPSE"] = "collapse";
    AnimationType["EXPAND"] = "expand";
    AnimationType["TRANSFORM"] = "transform";
})(AnimationType || (AnimationType = {}));
//# sourceMappingURL=animation.js.map